import { Spinner } from "alurkerja-ui";

export function Loading({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex items-center justify-center py-2">
      <Spinner /> {children ?? "Loading..."}
    </div>
  );
}
